<div class="container">
    <div class="body-medium">
        <span>{{ 'PAGES.HISTORY.BATTERY_TRANSFER_TITLE' | translate }}</span>
        <div class="value">
            <web-fading-span
                valueClass="number-regular"
                suffixClass="sub-headline-bold"
                [value]="value ? value : '-'"
                [suffix]="value ? suffix : ''"
            ></web-fading-span>
        </div>
    </div>
</div>
